import React, { useEffect } from "react"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import { useGetInterviewerQuery } from "../../../api/InterviewsApi"
import { Box, CircularProgress, Stack } from "@mui/material"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { RootState } from "../../../../../app/store"
import {
  setInterwiewersItems,
  setInterwiewersTotalPages,
} from "../tablePagination/model/pagination"
import { setInterwieverState } from "../../create/dialogs/model/Interviewers"
import { keycloakInstance } from "../../../../../shared/libs/keycloack/config"
import NoRowsOverlay from "../../../../../shared/ui/NoRowsOverlay"
import { Link, useSearchParams } from "react-router-dom"

const InterwiewersRow = ({ open, setOpen }: any) => {
  const dispatch = useDispatch()

  const pagination = useSelector((state: RootState) => state.pagination)
  const interwiewers = useGetInterviewerQuery(pagination?.InterwiewersPage)

  useEffect(() => {
    if (interwiewers.isSuccess) {
      dispatch(setInterwiewersItems(interwiewers?.data?.totalItems))
      dispatch(setInterwiewersTotalPages(interwiewers?.data?.totalPages))
    }
  }, [interwiewers])

  if (interwiewers.error) {
    return <TableRow>{JSON.stringify(interwiewers.error)}</TableRow>
  }

  if (interwiewers.isLoading) {
    return (
      <TableRow
        sx={{
          "&:hover ": {
            bgcolor: "transparent !important",
          },
        }}
      >
        <></>
      </TableRow>
    )
  }
  // не забыть про роли при редактировании onchange
  return (
    <>
      {interwiewers.data.items?.map((row: any) => (
        <React.Fragment key={row?.id}>
          <TableRow
            onClick={() => {
              keycloakInstance.realmAccess?.roles.some((role) =>
                ["hiring-admin"].includes(role),
              ) && setOpen({ ...open, openInterviewer: true })
              dispatch(setInterwieverState(row))
            }}
            hover
            key={row.id}
            sx={{
              borderBottom: (theme) =>
                theme.palette.mode === "light"
                  ? "10px solid rgba(255, 255, 255, 1)"
                  : "10px solid #272626",
              borderTop: (theme) =>
                theme.palette.mode === "light"
                  ? "10px solid rgba(255, 255, 255, 1)"
                  : "10px solid #272626",
              boxSizing: "content-box",
              borderRadius: "4px",
              maxHeight: "54px",
              whiteSpace: "nowrap",
              maxWidth: "auto",
              cursor: keycloakInstance.realmAccess?.roles.some((role) =>
                ["hiring-admin"].includes(role),
              )
                ? "pointer"
                : "default",
            }}
          >
            <TableCell
              sx={{
                bgcolor: "rgba(221, 234, 220, 1)",

                borderRadius: "4px",
                boxSizing: "border-box",
                minWidth: "68px",
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent={"space-between"}
              >
                <Box>{row.id}</Box>
              </Stack>
            </TableCell>
            <TableCell>{row.interviewer}</TableCell>
            <TableCell
              sx={{
                maxWidth: "200px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Link
                style={{
                  color: "black",
                  textDecoration: "underline",
                  textDecorationSkipInk: "none",
                }}
                target="_blank"
                color="inherit"
                to={row.permanentLink}
              >
                {row.permanentLink}
              </Link>
            </TableCell>
            <TableCell
              sx={{
                maxWidth: "200px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Link
                target="_blank"
                style={{
                  color: "black",
                  textDecoration: "underline",
                  textDecorationSkipInk: "none",
                }}
                to={row.temporaryLink}
              >
                {row.temporaryLink}
              </Link>
            </TableCell>
            <TableCell
              sx={{
                maxWidth: "200px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Link
                style={{
                  color: "black",
                  textDecoration: "underline",
                  textDecorationSkipInk: "none",
                }}
                target="_blank"
                color="inherit"
                to={row.tgLink}
              >
                {row.tgLink}
              </Link>
            </TableCell>
          </TableRow>
        </React.Fragment>
      ))}
      {interwiewers.data?.items?.length === 0 && <NoRowsOverlay />}
      {interwiewers?.data?.item !== 10 &&
        Array.from({
          length: Math.max(0, 10 - interwiewers.data.items.length),
        }).map((_, index) => (
          <TableRow key={index} sx={{ height: "40px" }}></TableRow>
        ))}
    </>
  )
}

export default InterwiewersRow
